import { Template } from "src/lib/templates";
import { shipmentAddressTemplate } from "./shipmentAddress";

export const template: Template = {
  name: "Shipment Address Form",
  template: [shipmentAddressTemplate],
};
